import {SET_SUBSCRIPTION_EMAIL, SET_SUBSCRIPTION_STATUS, SUBSCRIBE} from '../actions/subscribe';

const initialState = {
    subscriptionEmail: '',
    status: 'idle',
};

export const subscribeReducer = (state = initialState, action) => {
    const payload = action.payload;

    switch (action.type) {
        case SET_SUBSCRIPTION_EMAIL:
            return {...state, subscriptionEmail: payload, status: 'idle'};
        case SUBSCRIBE:
            return {...state, status: 'loading'};
        case SET_SUBSCRIPTION_STATUS:
            return {...state, status: payload};
        default:
            return state;
    }
};
